/**
 * Wix Channel API — manages the Wix site integration (self-managed Wix app).
 * Endpoints (all under /bot/wix, JWT):
 *   GET    /account        → connected site info, or null
 *   GET    /install-url    → Wix installer URL to send the merchant to
 *   POST   /link           → bind an install that started on the Wix side
 *   DELETE /disconnect     → disconnect the site
 *   POST   /sync           → sync one tab: products | pages | promotions
 *   POST   /sync-all       → sync every tab
 *   POST   /crawl-pages    → crawl the public site for static pages
 *   POST   /embed-widget   → (re)inject the chat widget on the Wix site
 */

import { getAuthHeaders } from './auth';
import { getBaseUrl, parseJson, buildUrl } from './utils';

const WIX_PATH = 'bot/wix';

function jsonHeaders() {
  return { 'Content-Type': 'application/json', Accept: 'application/json', ...getAuthHeaders() };
}

export async function getWixAccount() {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/account`), { method: 'GET', headers: jsonHeaders() });
  return parseJson(res);
}

export async function getWixInstallUrl() {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/install-url`), { method: 'GET', headers: jsonHeaders() });
  return parseJson(res);
}

export async function linkWixInstance(token) {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/link`), {
    method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ token }),
  });
  return parseJson(res);
}

export async function disconnectWix() {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/disconnect`), { method: 'DELETE', headers: jsonHeaders() });
  return parseJson(res);
}

export async function syncWix(tab) {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/sync`), {
    method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ tab }),
  });
  return parseJson(res);
}

export async function syncAllWix() {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/sync-all`), { method: 'POST', headers: jsonHeaders() });
  return parseJson(res);
}

export async function crawlWixPages() {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/crawl-pages`), { method: 'POST', headers: jsonHeaders() });
  return parseJson(res);
}

export async function embedWixWidget() {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/embed-widget`), { method: 'POST', headers: jsonHeaders() });
  return parseJson(res);
}

export async function removeWixWidget() {
  const res = await fetch(buildUrl(getBaseUrl(), `${WIX_PATH}/embed-widget`), { method: 'DELETE', headers: jsonHeaders() });
  return parseJson(res);
}

/** Channels page helper: { exists, site_url, accountData } like fetchWordpressFromDb. */
export async function fetchWixFromDb() {
  try {
    const data = await getWixAccount();
    if (data && data.instance_id) return { exists: true, site_url: data.site_url || '', accountData: data };
  } catch { /* not connected or not entitled */ }
  return { exists: false, site_url: '', accountData: null };
}
